import React from 'react'
import './How_To_Get_Started.css'

const How_To_Get_Started = () => {
  return (
    <section className='How_To_Get_Started'>
        <div className='container'>
            <div className='main_div'>
                <div className='row justify-content-center align-items-center'>
                    <div className='col-xl-4 col-lg-3 col-sm-7'>
                        <div className='left_img_div'>
                            <img src={process.env.PUBLIC_URL + "/assets/images/home/how_to_get_started/left.png"} className='left_img'/>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-5 col-md-6 col-sm-7 p-0 me-0 ms-0'>
                        <div className='middle_img_div'>
                            <img src={process.env.PUBLIC_URL + "/assets/images/home/how_to_get_started/middle1.png"} className='middle_img'/>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-5 p-0 me-0 ms-0'>
                        <div className='right_img_div'>
                            <img src={process.env.PUBLIC_URL + "/assets/images/home/how_to_get_started/right.png"} className='right_img'/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default How_To_Get_Started
